export const formatNumberHelper = (numberToFormat) => {
  const intl = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return intl.format(numberToFormat);
};
